/**
 * Returns true when two arrays have the same length and every element at the
 * same index is reference-equal (===).
 *
 * Used by cached selectors to detect when filter+sort produces a structurally
 * identical result (e.g. only a column width changed — hidden/order/pinned are
 * unchanged), avoiding unnecessary downstream re-renders.
 */
export function arraysShallowEqual<T>(a: readonly T[], b: readonly T[]): boolean {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}